// src/pages/About.js (or components/About.js)
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import '../styles/About.css'; // Using existing CSS

// Placeholder image (replace with a relevant image, e.g., team, office, concept)
const aboutImagePlaceholder = 'https://placehold.co/600x400/1E5A6C/FFFFFF?text=About+Accountaxation';

function About() {
  const teamMembers = [
    { name: "GAGANDEEP SINGH", profession: "CHARTERED ACCOUNTANT" },
    { name: "ANKIT JAISWAL", profession: "CHARTERED ACCOUNTANT" },
    { name: "AMAN SINGH", profession: "COMPANY SECRETARY" },
    { name: "RAJNI MIGLANI", profession: "COMPANY SECRETARY" },
    { name: "SUNIL KUMAR", profession: "ADVOCATE" },
    { name: "PBA SRINIVASAN", profession: "ADVOCATE" },
    { name: "KARAN SONI", profession: "COMPANY SECRETARY" },
    { name: "PRACHI GOEL", profession: "CHARTERED ACCOUNTANT" },
    { name: "MANISH BAJAJ", profession: "CHARTERED ACCOUNTANT" },
    { name: "HARPREET SINGH", profession: "ADVOCATE" },
    { name: "GANAT JUNEJA", profession: "ADVOCATE" }
  ];
  return (
    <div className="about-page">
      <Helmet>
        {/* SEO Meta Tags */}
        <title>About Accountaxation | Your Trusted Tax & Accounting Partner</title>
        <meta name="description" content="Learn about Accountaxation Services - specializing in taxation, accountancy, and corporate services across India. We work with you, offering 24/7 expert support." />
        <meta name="keywords" content="about Accountaxation, accounting firm India, tax consultants India, corporate services, financial advisory" />
      </Helmet>

      {/* Page Header Section - Reuse style from other pages if available */}
      <section className="page-header about-header">
        <div className="container">
          <h1>About Accountaxation Services</h1>
          <p className="subtitle">Your dedicated partner for navigating finance and compliance in India.</p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="about-content">
        <div className="container">
          <div className="about-grid">

            {/* Left Column: Text Content */}
            <div className="about-text">
              <h2>Who We Are</h2>
              <p>
                ACCOUNTAXATION SERVICES is a long lasting business consulting firm specialized in Start-Ups, Corporate Laws, Taxation (Direct & Indirect), International Taxation, GST Accounting, Import Export, Govt Registration & Licenses, Transfer Pricing, Transaction Advisory, Book Keeping, Audit and Assurance, Business Registrations, Corporate Financial and Risk Advisory. Our team of experts offers solutions to meet individual client needs in today's market.
              </p>
            </div>

            {/* Right Column: Image */}
            <div className="about-image">
              <img
                src={aboutImagePlaceholder}
                alt="About Accountaxation Services"
                onError={(e) => e.target.src = 'https://placehold.co/600x400/cccccc/ffffff?text=Image+Not+Found'}
              />
            </div>
          </div>

          {/* New Mission & Vision Section (Split Layout) */}
          <div className="mission-vision-section">
            <div className="mv-card vision-card">
              <h3>Our Vision</h3>
              <p>
                ACCOUNTAXATION SERVICES focus on providing customized business solutions to every client, keeping customer satisfaction as our primary goal. Our whole sole vision is to become a one-stop solution for our entire client's financial, taxation and corporate law needs as well as constantly improving our firm with changing market trends.
              </p>
              <p>
                We strive to empower our clients with cutting-edge solutions that redefine industry standards and create sustainable value. Through relentless dedication to quality and customer satisfaction, we aim to foster long-term partnerships and inspire positive change in the global marketplace. We firmly believe in ethical business practices. What makes us stand apart from our competitors is our team of highly qualified and experienced professionals who are trained periodically so that learning never stops, and they are updated with market developments and trends to improve their skill-set.
              </p>
            </div>

            <div className="mv-card mission-card">
              <h3>Our Mission</h3>
              <p>
                ACCOUNTAXATION SERVICES revolves around providing essential support and solutions to businesses, ensuring their operations to run smoothly and efficiently. We ensure client satisfaction and success by delivering high-quality services that meet or exceed their expectations.
              </p>
              <p>
                We consult clients to achieve operational efficiency and cost-effectiveness through streamlined processes and strategic management. We also combine global capabilities with local market knowledge to provide comprehensive services across different jurisdictions and regions.
              </p>
            </div>
          </div>

          {/* Why Choose Us Section - Updated to match Image Text */}
          <div className="why-choose-us">
            <h2>Why Us?</h2>
            <div className="why-us-content">
              <p>
                Leaders and Professionals at ACCOUNTAXATION SERVICES excel at what they do. As Trusted Partner, we prioritize exceptional customer service & aim to be with you at every step of the way. Count on ACCOUNTAXATION SERVICES to accompany you on your path to success.
              </p>
              <p>
                The ACCOUNTAXATION SERVICES vision is to provide continued excellent and practice timely solutions to the clients and with its efforts to be universally recognised as a full service corporate partnership firm. The ACCOUNTAXATION SERVICES believes in the importance of partners' involvement and accessibility to its clients. It also ensures that the clients are kept well informed of industry developments on a regular basis.
              </p>
            </div>
          </div>


          <div className="team-section">
            <h2>Meet Our Team</h2>
            <p>Our firm is powered by a dedicated team of highly qualified and experienced professionals.</p>
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-member-card">
                  <h4>{member.name}</h4>
                  <p>{member.profession}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Call to Action Section - Reuse style from other pages */}
      <section className="cta-section about-cta">
        <div className="container">
          <h2>Have Questions or Need Assistance?</h2>
          <p>We're here to help. Reach out to discuss your specific requirements.</p>
          <Link to="/contact" className="cta-button cta-primary-teal">Contact Us Now</Link>
        </div>
      </section>

    </div>
  );
}

export default About;
